import React from 'react';
import { useNavigate } from "react-router-dom";
import CounterCard from './CounterCard';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import FeatureCard from './FeatureCard';
import FeatureSection from './FeatureSection';
import 'animate.css';
import './Home.css';
// import CounterCard from './components/CounterCard';
import Testimonials from './Testimonials';

import backVideo from "../components/images/back.mp4";
import { useState } from "react";

import NationXPopup from "../components/NationXPopup";



import nb1 from "../components/images/MIX.jpg";
import nb4 from "../components/images/AC1.jpg";
import nb7 from "../components/images/MERGCD.jpg";
import nb3 from "../components/images/SCOOTY.png";
import nb2 from "../components/images/T-cops.png";
import nb5 from "../components/images/Airbrus.jpg";
import nb6 from "./images/nx.jpg";
//////////
import img from "./images/ac so.jpg";
import img1 from "./images/tv so.jpg";
import img2 from "./images/ev scooty.jpg";
import img4 from "./images/tcop.jpg";
import img3 from "./images/buds nation nx-Recovered.jpg";

// import bannerAi from "./images/bannerAi.png";
import bannerAi from "./images/Banner 1.jpg";


import webbanner from "./images/Iphone Final Banner.jpg";
// import banner1 from "./images/banner1.png";
import Testimonials1 from './Testimonials1';
import inch from "./images/98inch.jpeg"
import ledad from "./images/led-ad.jpeg"
// import panindia from "./images/com-mappvideo.mp4"
import front from "./images/frontspeaker.jpeg"
import ChatBot from "./ChatBot";

import 'animate.css';

function Home() {
 
const [showNationXPopup, setShowNationXPopup] = useState(false);




  const navigate = useNavigate();

 const handleNavigate = (title) => {
  if (title === "EV") navigate("/ev");
  else if (title === "AC") navigate("/ac");
  else if (title === "Finance Locker") navigate("/tcops");
  else if (title === "TV") navigate("/led");
  else if (title === "Red Wolf Nationx") {
    window.open("https://www.nationx.in/index.php", "_blank");
  }
};

 const products = [

  {
    title: "Finance Locker",
    desc: `Secure your finances with T-COPS—easy, reliable, and trusted.
     T-COPS offers an intuitive, user-friendly interface that ensures smooth 
     operations while enabling effortless tracking of payments and due dates. 
     It provides top-level security for all transactions and keeps you informed through 
     automated reminders. With anytime, anywhere access to your financial records, T-COPS delivers
      a complete, stress-free money management system, acting as a secure finance locker you can rely on.`,
    img: img4, // replace with finance locker image
  },
 {
  title: "EV",
  desc: `Engineered for the modern commuter, our high-performance electric
  vehicle delivers a refined balance of power, efficiency, and sustainability. 
  A long-lasting battery enables extended travel with fewer charging interruptions,
   while the smooth, silent motor ensures an effortlessly comfortable ride. With sleek, contemporary styling designed 
   for urban lifestyles, this electric vehicle redefines everyday mobility—cleaner, smarter, and more convenient.`,
  img: img2 // replace with your EV image
},

{
  title: "TV",
  desc: `Experience cinematic brilliance at home with our advanced LED TV.
   Designed to deliver stunning clarity, the high-definition display produces 
   sharp details and vibrant colors that bring every scene to life. An immersive audio 
   system enhances your viewing experience, while the sleek, contemporary design 
   blends effortlessly into any living space. Smart features provide seamless access 
   to your favorite apps—elevating everyday entertainment to a premium experience.`,
  img: img1, // replace with your LED TV image
},
{
  title: "AC",
  desc: `Experience intelligent cooling crafted for modern living. Red Wolf Air Conditioners combine advanced inverter
technology with energy-efficient performance to deliver consistent comfort in every season. Designed for silent
operation and long-lasting reliability, each unit blends seamlessly into contemporary interiors.
 With intuitive controls and a sleek, modern aesthetic, Red Wolf ACs redefine home comfort with precision, performance, and peace of mind.`,
  img: img, // replace with your RedWolf AC image
},

   {
    title: "Red Wolf Nationx",
    desc: `Elevate your everyday mobile experience with Red Wolf NationX’s premium range of mobile accessories.
     Thoughtfully engineered for performance and durability, our collection—from fast chargers and immersive earphones
      to precision-fit protective cases—combines cutting-edge technology with refined design. Seamlessly compatible across
       a wide range of devices, NationX accessories deliver reliability, style, and effortless functionality for life on the move.`,
    img: img3, // replace with mobile accessory image
  },
];


//  const products = [

//   {
//     title: "T-Cops Finance Locker",
//     desc: `Secure your finances with T-Cops Finance Locker.
// Fast and reliable EMI recovery solution.
// User-friendly interface for smooth operations.
// Track your payments and due dates effortlessly.
// Protect your transactions with top security features.
// Automated reminders keep you updated at all times.
// Access your financial records anytime, anywhere.
// Stay stress-free with our complete money management system.`,
//     img: img4, // replace with finance locker image
//   },
//  {
//   title: "Electric Vehicle",
//   desc: `High-performance electric vehicle designed for modern commuters.
// Long-lasting battery ensures extended travel without frequent charging.
// Eco-friendly design helps reduce your carbon footprint.
// Smooth and silent motor provides a comfortable ride.
// Smart safety and navigation features for a secure journey.
// Advanced technology maximizes energy efficiency and reliability.
// Sleek, modern styling perfect for urban lifestyles.
// Experience innovation, freedom, and convenience on every drive.`,
//   img: img2 // replace with your EV image
// },

// {
//   title: "LED TV",
//   desc: `Experience stunning visuals with this LED TV.
// High-definition LED display delivers sharp and vibrant images.
// Immersive audio system enhances your viewing experience.
// Sleek and modern design complements any living space.
// Smart features allow streaming of your favorite apps.
// User-friendly interface ensures easy navigation.
// Energy-efficient technology saves power without compromise.
// Upgrade your home entertainment with this LED TV.`,
//   img: img1, // replace with your LED TV image
// },
// {
//   title: "Red Wolf Air Conditioner",
//   desc: `Premium-quality air conditioners from Red Wolf.
// Energy-efficient cooling for ultimate home comfort.
// Advanced inverter technology ensures consistent temperature.
// Silent operation keeps your living space peaceful.
// Sleek and modern designs complement any room.
// User-friendly controls for hassle-free operation.
// Durable and reliable for long-term use.
// Upgrade your home cooling experience with Red Wolf AC.`,
//   img: img, // replace with your RedWolf AC image
// },

//    {
//     title: "NationX Mobile Accessories",
//     desc: `Premium-quality mobile accessories from NationX.
// Chargers, earphones, protective cases, and more.
// Enhance your smartphone experience effortlessly.
// Durable and stylish designs to suit your devices.
// Compatible with a wide range of mobile models.
// High-performance products for everyday use.
// Upgrade your mobile setup with the latest accessories.
// Stay connected, powered, and protected with NationX products.`,
//     img: img3, // replace with mobile accessory image
//   },
// ];




  return (

    <div className="App">

      <header className="App-header">




  <section className="bg-video-section">
     
      <video
        className="bg-video"
        src={backVideo}
        autoPlay
        loop
        muted
        playsInline
      />

    
      <div className="video-overlay"></div>

      

      <div className="carousel-3d">
        <div className="carousel-ring">
          <div className="banner-3d banner-1">
            <img src={nb7} alt="EV Banner" />
          </div>

          <div className="banner-3d banner-2">
            <img src={nb2} alt="EV Banner" />
          </div>

          <div className="banner-3d banner-3">
            <img src={nb3} alt="EV Banner" />
          </div>

          <div className="banner-3d banner-4">
            <img src={nb6} alt="EV Banner" />
            
          </div>
          {/* <div className="banner-3d banner-5">
  <img src={nb5} alt="EV Banner" />
</div>

<div className="banner-3d banner-6">
  <img src={nb6} alt="EV Banner" />
</div> */}

        </div>
      </div>
    </section>   

        {/* home page code */}

        {/* <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={bannerAi} className="d-block w-100" alt="..." />
            </div>
            <div className="carousel-item">
              <img src={inch} className="d-block w-100" alt="..." />
            </div>
           
            <div className="carousel-item">
              <img src={webbanner} className="d-block w-100" alt="..." />
            </div>
            <div className="carousel-item">
              <img src={front} className="d-block w-100" alt="..." />
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div> */}

          <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={nb1} className="d-block w-100" alt="..." />
            </div>
            {/* <div className="carousel-item">
              <img src={nb2} className="d-block w-100" alt="..." />
            </div>
           
            <div className="carousel-item">
              <img src={nb3} className="d-block w-100" alt="..." />
            </div>
            <div className="carousel-item">
              <img src={nb4} className="d-block w-100" alt="..." />
            </div>
            <div className="carousel-item">
              <img src={nb5} className="d-block w-100" alt="..." />
            </div>
          <div className="carousel-item">
              <img src={nb6} className="d-block w-100" alt="..." />
            </div>  */}
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>


        {/* counter  */}

        {/* <section className="stats-section text-center">
          <div className="container">
            <div className="row justify-content-center g-4">

              <div className="col-md-4">
                <CounterCard target={65} label="Super Distributors" />
              </div>

              <div className="col-md-4">
                <CounterCard target={390} label="Distributors" />
              </div>

              <div className="col-md-4">
                <CounterCard target={23400} label="Retailers" />
              </div>

            </div>
          </div>
        </section> */}




{/* <section className="zigzag-section">
  <h2 className="zigzag-title">Our Product</h2>

  {products.map((item, index) => (
    <div
      className={`zigzag-row ${index % 2 !== 0 ? "reverse" : ""}`}
      key={index}
    >
    
      <div className="zigzag-image">
        <img src={item.img} alt={item.title} />
      </div>

   
      <div className="zigzag-content">
        <h3>{item.title}</h3>
        <p>{item.desc}</p>
        <button className="zigzag-btn">View Details</button>
      </div>
    </div>
  ))}
</section> */}


<section className="zigzag-section">
      <h2 className="zigzag-title">Our Products</h2>

      {products.map((item, index) => (
        <div
          className={`zigzag-row ${index % 2 !== 0 ? "reverse" : ""}`}
          key={index}
        >
          {/* IMAGE */}
          <div
            className="zigzag-image"
            onClick={() => handleNavigate(item.title)}
          >
            <img src={item.img} alt={item.title} />
          </div>

          {/* CONTENT */}
          <div
            className="zigzag-content"
            onClick={() => handleNavigate(item.title)}
          >
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
            <button className="zigzag-btn">View Details</button>
          </div>
        </div>
      ))}
    </section>









        {/* counter */}

        {/* <CounterCard /> */}

        {/* <FeatureCard/> */}

        {/* <FeatureSection /> */}



        {/* journey */}

        {/* <section id="journey">
          <div class="timeline">
            <h1 class="section-title">
              <span class="ev">Our</span> <span class="red">Journey</span>
            </h1>
          
            <div class="timeline__event  animated fadeInUp delay-3s timeline__event--type1">
              <div class="timeline__event__icon ">
              

              </div>
              <div class="timeline__event__date">
                July 2019
              </div>
              <div class="timeline__event__content ">
                <div class="timeline__event__title">
                  Stage 1
                </div>
                <div class="timeline__event__description">
                  <p>Finance Locker Developed by Rohit Jain ( Founder & Chairman)</p>
                </div>
              </div>
            </div>

         

            <div class="timeline__event animated fadeInUp delay-2s timeline__event--type2">
              <div class="timeline__event__icon">
           

              </div>
              <div class="timeline__event__date">
                Oct 2019
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 2
                </div>
                <div class="timeline__event__description">
                  <p>Pankaj Chaturvedi have joined us as a (Co- Founder & Director)</p>
                </div>
              </div>
            </div>

        

            <div class="timeline__event animated fadeInUp delay-1s timeline__event--type3">
              <div class="timeline__event__icon">
              
              </div>
              <div class="timeline__event__date">
                Nov 2019
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 3
                </div>
                <div class="timeline__event__description">
                  <p>Introducing Finance Locker in all States of India.</p>
                </div>

              </div>
            </div>


            <div class="timeline__event animated fadeInUp timeline__event--type1">
              <div class="timeline__event__icon">
          

              </div>
              <div class="timeline__event__date">
                Dec 2022
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 4
                </div>
                <div class="timeline__event__description">
                  <p>To increase the power of Finance Locker, we create sales team.</p>
                </div>
              </div>
            </div>

          
            <div class="timeline__event  animated fadeInUp delay-3s timeline__event--type1">
              <div class="timeline__event__icon ">
               

              </div>
              <div class="timeline__event__date">
                October 2023
              </div>
              <div class="timeline__event__content ">
                <div class="timeline__event__title">
                  Stage 5
                </div>
                <div class="timeline__event__description">
                  <p> We are now recognized as Red Wolf Info Tech Pvt Ltd.</p>
                </div>
              </div>
            </div>

           

            <div class="timeline__event animated fadeInUp delay-2s timeline__event--type2">
              <div class="timeline__event__icon">
           

              </div>
              <div class="timeline__event__date">
                November 2023
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 6
                </div>
                <div class="timeline__event__description">
                  <p>We established our dedicated IT team for innovation and growth.</p>
                </div>
              </div>
            </div>

          

            <div class="timeline__event animated fadeInUp delay-1s timeline__event--type3">
              <div class="timeline__event__icon">
            

              </div>
              <div class="timeline__event__date">
                December 2023
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 7
                </div>
                <div class="timeline__event__description">
                  <p>We became India's No. 1 Finance Locker, revolutionizing secure financial management with cutting-edge
                    technology.</p>
                </div>

              </div>
            </div>

         

            <div class="timeline__event animated fadeInUp timeline__event--type1">
              <div class="timeline__event__icon">
              

              </div>
              <div class="timeline__event__date">
                February 2024
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 8
                </div>
                <div class="timeline__event__description">
                  <p>We proudly celebrate 4.5 years of success with our Annual General Meeting (AGM).</p>
                </div>
              </div>
            </div>

       
            <div class="timeline__event  animated fadeInUp delay-3s timeline__event--type1">
              <div class="timeline__event__icon ">
              

              </div>
              <div class="timeline__event__date">
                March 2024
              </div>
              <div class="timeline__event__content ">
                <div class="timeline__event__title">
                  Stage 9
                </div>
                <div class="timeline__event__description">
                  <p>We successfully launched Red Wolf EV, revolutionizing the future of electric mobility and AI.</p>
                </div>
              </div>
            </div>


            <div class="timeline__event animated fadeInUp delay-2s timeline__event--type2">
              <div class="timeline__event__icon">
               

              </div>
              <div class="timeline__event__date">
                March 2025
              </div>
              <div class="timeline__event__content">
                <div class="timeline__event__title">
                  Stage 10
                </div>
                <div class="timeline__event__description">
                  <p>In March, Red Wolf stepped into the home appliances segment, including Smart TVs and Bluetooth speakers.</p>
                </div>
              </div>
            </div>




          </div>
        </section> */}




        {/* ///////////////////////////////// */}
        {/* <ChatBot /> */}

        <a
          href="https://wa.me/9214309236"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-icon"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
        {/* <Testimonials1 /> */}
        {/* <Testimonials /> */}
      </header>
    </div>
  );
}

export default Home;